// View 1 is same as View 3, except there is a button to approve the profile:

import { useEffect, useState, useRef } from "react";
import { authorizedHttpPost } from "../../../api/httpCalls";
import urls from '../../../api/urls.json'
import Loader from "../../Loader";
import './View1.css'
import placeHolder from '../../../assests/placeholder_image.png'
import previousInactive from '../../../assests/arrow_back_grey.png'
import previousActive from '../../../assests/arrow_back.png'
import nextInactive from '../../../assests/arrow_forward_grey.png'
import nextActive from '../../../assests/arrow_forward.png'
import styled, { css } from "styled-components";
import ImageWrapperSmall from "../../ImageWrapperSmall";
import { BaseButton } from "../../../styles/ButtonStyles";
import CropImage from "../../CropImage";
import { convertTimestampToFormattedDate, getSafeMediaUrl } from "../../../utils";


const ImageContainerDiv = styled.div`
    margin-top: 10%;
    display: flex;
    flex-direction: column;
`;

const ApproveView = styled.div`
  border: solid 5px #53e03f;
  width: 50px;
  height: 50px;
  margin: 40px 20px 0px 0;
  border-radius: 50px;
  background-color: #ffffff;
  cursor: pointer;
  ${props =>
        props.selected &&
        css`
      background-color: #53e03f;
    `}
`;

const DisapproveView = styled.div`
  margin: 40px 0 0 0;
  border: solid 5px #484848;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background-color: #ffffff;
  cursor: pointer;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
    `}
`;

const ApproveButton = styled.button`
    width: 175px;
    height: 66px;
    margin-top: 37px;
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px ;
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: 'Gilory-Bold';
    cursor: pointer;
    color: white;
    background-color: rgb(14 43 54);
    ${props =>
        props.className === 'approveInActiveButton' &&
        css`
            background-color: white;
            color: black`
    }
`;


const View1 = ({ profilesData, pageNumber, totalPageNumber, afterSave, updatePage, isViewthree }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [profiles, setProfiles] = useState(profilesData);
    const [decoy, setDecoy] = useState(false);
    const [approve, setApprove] = useState(profilesData);
    const [reject, setReject] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [approvedProfile, setApprovedProfile] = useState([]);
    const [showCropImage, setShowCropImage] = useState(false);
    const [cropPhoto, setCropPhoto] = useState('');
    const [ignoredProfiles, setIgnoredProfiles] = useState([]);


    useEffect(() => {
        setPage(pageNumber);
        setTotalPages(totalPageNumber);
    }, [pageNumber, totalPageNumber, profiles]);


    const deleteImage = (refValue, photoIdToDelete) => {
        const foundIndex = profiles.findIndex(item => item.ref === refValue);
        if (foundIndex !== -1) {
            const updatedImages = profiles[foundIndex].updated_images;
            const indexToDelete = updatedImages.findIndex(img => img.photo_id === photoIdToDelete);
            if (indexToDelete !== -1) {
                updatedImages.splice(indexToDelete, 1);
                profiles[foundIndex].updated_images = updatedImages;
                setProfiles(profiles)
                setDecoy(!decoy)
            }
        }
    }

    const addImage = (path, refValue) => {
        const foundIndex = profiles.findIndex(item => item.ref === refValue);
        if (foundIndex !== -1) {
            const updatedImages = profiles[foundIndex].updated_images;
            updatedImages.push({ photo: path });
            profiles[foundIndex].updated_images = updatedImages;
            setProfiles(profiles)
            setDecoy(!decoy)
        }
    }

    const setSelected = (refValue, photoId) => {
        const foundIndex = profiles.findIndex(item => item.ref === refValue);
        if (foundIndex !== -1) {
            const updatedImages = profiles[foundIndex].updated_images;
            updatedImages.forEach(photo => {
                photo.photo_id === photoId ? photo.selected = true : photo.selected = false;
            });
            profiles[foundIndex].updated_images = updatedImages;
            setProfiles(profiles)
            setDecoy(!decoy)
        }
    }

    const handleApprove = (refValue) => {
        const alreadyInApprove = approve.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        if (alreadyInApprove !== -1) {
            setIgnoredProfiles([...ignoredProfiles, approve[alreadyInApprove]])
            setApprove(approve.filter(item => item.ref !== refValue))
            return;
        }
        const foundIndex = reject.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        if (foundIndex !== -1) {
            setApprove([...approve, reject[foundIndex]])
            setReject(reject.filter(item => item.ref !== refValue))
        }
        const foundInIgnore = ignoredProfiles.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        if (foundInIgnore !== -1) {
            setApprove([...approve, ignoredProfiles[foundInIgnore]])
            setIgnoredProfiles(ignoredProfiles.filter(item => item.ref !== refValue))
        }
        setDecoy(!decoy)
    }

    const handleReject = (refValue) => {
        const alreadyInReject = reject.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        if (alreadyInReject !== -1) {
            setIgnoredProfiles([...ignoredProfiles, reject[alreadyInReject]])
            setReject(reject.filter(item => item.ref !== refValue))
            return;
        }
        const foundIndex = approve.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        if (foundIndex !== -1) {
            setReject([...reject, approve[foundIndex]])
            setApprove(approve.filter(item => item.ref !== refValue))
        }
        const foundInIgnore = ignoredProfiles.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        if (foundInIgnore !== -1) {
            setReject([...reject, ignoredProfiles[foundInIgnore]])
            setIgnoredProfiles(ignoredProfiles.filter(item => item.ref !== refValue))
        }
        setDecoy(!decoy)
    }

    const isProfileApproved = (refValue) => {
        const foundIndex = approvedProfile.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        if (foundIndex !== -1) {
            return true;
        }
        return false;
    }

    const handleApproveProfile = (refValue) => {
        if (isProfileApproved(refValue)) {
            const foundIndex = approvedProfile.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
            if (foundIndex !== -1) {
                setApprovedProfile(approvedProfile.filter(item => item.ref !== refValue))
            }
        } else {
            const foundIndex = profiles.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
            if (foundIndex !== -1) {
                setApprovedProfile([...approvedProfile, profiles[foundIndex]])
            }
        }
        setDecoy(!decoy)
    };

    const isRefFound = (refValue, type) => {
        let foundIndex = -1;
        if (type === 'approve') {
            foundIndex = approve.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        } else {
            foundIndex = reject.findIndex(item => item !== 'undefined' ? item.ref === refValue : null);
        }
        if (foundIndex !== -1) {
            return true;
        }
        return false;
    }

    const handlePageChange = (direction) => {
        let intPage = parseInt(page);
        let intTotalPages = parseInt(totalPages);
        if (direction === 'next') {
            if (intPage === intTotalPages) {
                return;
            }
            updatePage(intPage + 1)
        } else {
            if (intPage === 1) {
                return;
            }
            updatePage(intPage - 1)
        }
    }

    const handleSave = async () => {
        let params = isViewthree ? { approve: approve, reject: reject, approve_profile: approvedProfile } : { approve: approve, reject: reject };
        let url = isViewthree ? urls.APPROVE_REJECT_MULTIPLE_IMAGES_DISAPPROVED : urls.APPROVE_REJECT_MULTIPLE_IMAGES;
        setIsLoading(true);
        let response = await authorizedHttpPost(url, params);
        if (response.status) {
            afterSave();
        }
        setIsLoading(false);
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'ArrowLeft') {
                handlePageChange('prev')
            } else if (event.key === 'ArrowRight') {
                handlePageChange('next')
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    const dragOverItem = useRef();
    const dragImageUrl = useRef();

    const dragStart = (e, position, url) => {
        dragImageUrl.current = url;
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = (profileRef) => {
        setDecoy(!decoy);
        profiles.map((profile, index) => {
            if (profile.ref === profileRef) {
                profile.updated_images[dragOverItem.current] = { photo: dragImageUrl.current };
            }
        })
        setProfiles(profiles);

        dragImageUrl.current = null;
        dragOverItem.current = null;
    }

    const saveCroppedImage = (croppedImage) => {
        setDecoy(!decoy);
        profiles.map((profile, index) => {
            if (profile.ref === localStorage.getItem('profileCropRef')) {
                profile.updated_images[localStorage.getItem('profileCropIndex')] = { photo: croppedImage };
            }
        }
        )
        setShowCropImage(false);
        localStorage.removeItem('profileCropRef');
        localStorage.removeItem('profileCropIndex');
    }

    const showImageCrop = (photo) => {
        setCropPhoto(photo)
        setShowCropImage(true);
    }

    const closeModal = () => {
        setShowCropImage(false);
        localStorage.removeItem('profileCropRef');
        localStorage.removeItem('profileCropIndex');
    }

    return (
        <div>
            {isLoading && <Loader isLoading={isLoading} />}
            {showCropImage ? <CropImage photo={cropPhoto} closeModal={closeModal} saveCroppedImage={saveCroppedImage} /> : null}
            <ImageContainerDiv>
                {
                    profiles.map((profile, index) => {
                        return (
                            <div className="profileImages">
                                <div className="oldAvatar">
                                    <img className="imageView" src={getSafeMediaUrl(profile.old_avatar, placeHolder)} onError={(e) => e.target.src = placeHolder} alt="profile" />
                                </div>
                                <div className="updatedImages">
                                    {
                                        [0, 1, 2, 3].map((image, index) => {
                                            return (
                                                <div
                                                    onDragStart={(e) => dragStart(e, index, profile.updated_images[image].photo)}
                                                    onDragEnter={(e) => dragEnter(e, index)}
                                                    onDragEnd={() => dropImage(profile.ref)}

                                                >
                                                    <ImageWrapperSmall key={index} src={profile.updated_images[index]} profileRef={profile.ref} deleteImage={deleteImage} showDelete={profile.updated_images.length > 1} showSelect={true} addImage={addImage} setSelected={setSelected} showImageCrop={showImageCrop} index={index} />
                                                </div>
                                            )
                                        })
                                    }
                                    <div style={{ "display": "table-column" }}>
                                        <div style={{ display: 'flex', marginTop: '-20px' }}>
                                            <ApproveView onClick={() => handleApprove(profile.ref)} selected={isRefFound(profile.ref, 'approve')} />
                                            <DisapproveView onClick={() => handleReject(profile.ref)} selected={isRefFound(profile.ref, 'reject')} />
                                            {isViewthree && <ApproveButton onClick={() => handleApproveProfile(profile.ref)} isProfileApproved className={isProfileApproved(profile.ref) ? 'notApproved' : 'approveInActiveButton'}>Approve</ApproveButton>}
                                        </div>
                                        {
                                            isViewthree && <div>
                                                {
                                                    profile.disapproved_by && <span>{profile.disapproved_by}</span>
                                                }
                                                {
                                                    profile.disapproved_date && <span>{convertTimestampToFormattedDate(profile.disapproved_date)}</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>
                        )
                    })
                }
            </ImageContainerDiv>
            <div className="buttonDivImage">
                {
                    parseInt(page) === 1 ? <img className="previous" src={previousInactive} alt="previous" /> : <img className="previous" src={previousActive} alt="previous" onClick={() => handlePageChange('prev')} />
                }
                {
                    parseInt(page) === parseInt(totalPages) ? <img className="marginLeft20" src={nextInactive} alt="next" /> : <img className="marginLeft20" src={nextActive} alt="next" onClick={() => handlePageChange('next')} />
                }
                <BaseButton onClick={() => handleSave()} className="saveButton">Save</BaseButton>
            </div>
        </div >
    )
};

export default View1;
